export const SERVICE_PROJECT_ASSOCIATION_TYPES = {
	CHANGE_MANAGEMENT: 'CHANGE_MANAGEMENT',
} as const;

// Latency SLO thresholds in milliseconds
export const SLO_THRESHOLD_TTI = 4000;
export const SLO_THRESHOLD_TTR = 1000;
export const SLO_THRESHOLD_CREATE_SERVICE_INTERACTION = 5000;
export const SLO_THRESHOLD_UPDATE_SERVICE_INTERACTION = 5500;

export const MISSING_ERROR_TYPE = 'MISSING_ERROR_TYPE';

export const OPSGENIE_STAGING_URL = 'https://app.opsgeni.us';
export const OPSGENIE_PROD_URL = 'https://app.opsgenie.com';
